import React from "react";

type RelatorioQueryErrorAlertProps = {
  message: string;
};

const RelatorioQueryErrorAlert: React.FC<RelatorioQueryErrorAlertProps> = ({
  message,
}) => (
  <div
    className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-8 text-center text-sm text-amber-950"
    role="alert"
  >
    <p className="font-semibold">Não foi possível carregar o relatório</p>
    <p className="mt-2 text-amber-900">{message}</p>
  </div>
);

export default RelatorioQueryErrorAlert;
